import { render, staticRenderFns } from "./MapaMundial.vue?vue&type=template&id=321b992b&scoped=true"
import script from "./MapaMundial.vue?vue&type=script&lang=js"
export * from "./MapaMundial.vue?vue&type=script&lang=js"
import style0 from "./MapaMundial.vue?vue&type=style&index=0&id=321b992b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b992b",
  null
  
)

export default component.exports